<div class="flex flex-col h-full max-w-2xl w-full">
    <!-- Header -->
    <div class="flex flex-row justify-between items-center pb-4">
        <span class="text-lg font-semibold">Importar Usuários em Lote</span>
        <button mat-icon-button mat-dialog-close [disabled]="isUploading()">
            <mat-icon svgIcon="heroicons_outline:x-circle"></mat-icon>
        </button>
    </div>

    <!-- Template Download Section -->
    <div class="flex flex-col space-y-2 mb-6 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-200 dark:border-blue-800">
        <div class="flex flex-row items-center space-x-2">
            <mat-icon svgIcon="heroicons_outline:information-circle" class="text-blue-600 dark:text-blue-400"></mat-icon>
            <span class="text-sm font-medium text-blue-800 dark:text-blue-300">Formato do Documento</span>
        </div>
        <p class="text-sm text-blue-700 dark:text-blue-400">
            Baixe o template CSV para garantir que o formato está correto.
        </p>
        <button mat-stroked-button color="primary" (click)="downloadTemplate()" [disabled]="isUploading()" class="w-fit">
            <mat-icon svgIcon="heroicons_outline:arrow-down-tray"></mat-icon>
            <span class="ml-2">Baixar Template CSV</span>
        </button>
    </div>

    <!-- Upload Area -->
    <div class="flex flex-col space-y-4">
        @if (!selectedFile()) {
        <!-- Drag and Drop Zone -->
        <div
            class="flex flex-col items-center justify-center p-12 border-2 border-dashed rounded-lg transition-all duration-200 cursor-pointer"
            [class.border-gray-300]="!isDragging()"
            [class.border-blue-500]="isDragging()"
            [class.bg-blue-50]="isDragging()"
            [class.dark:border-gray-600]="!isDragging()"
            [class.dark:border-blue-400]="isDragging()"
            [class.dark:bg-blue-900]="isDragging()"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="onDrop($event)"
            (click)="openFileSelector()">
            
            <mat-icon class="icon-size-16 mb-4 text-gray-400" svgIcon="heroicons_outline:cloud-arrow-up"></mat-icon>
            
            <div class="flex flex-col items-center space-y-2 text-center">
                <span class="text-lg font-medium text-gray-700 dark:text-gray-300">
                    Arraste e solte o arquivo CSV aqui
                </span>
                <span class="text-sm text-gray-500 dark:text-gray-400">
                    ou
                </span>
                <button mat-stroked-button type="button" [disabled]="isUploading()">
                    <mat-icon svgIcon="heroicons_outline:folder-open"></mat-icon>
                    <span class="ml-2">Selecionar arquivo do computador</span>
                </button>
            </div>
            
            <p class="text-xs text-gray-400 dark:text-gray-500 mt-4">
                Apenas arquivos CSV são aceitos
            </p>
        </div>
        }
        
        @if (selectedFile()) {
        <!-- Selected File Display -->
        <div class="flex flex-col space-y-3 p-4 bg-green-50 dark:bg-green-900/20 rounded-lg border border-green-200 dark:border-green-800">
            <div class="flex flex-row items-center justify-between">
                <div class="flex flex-row items-center space-x-3">
                    <mat-icon class="text-green-600 dark:text-green-400" svgIcon="heroicons_outline:document-check"></mat-icon>
                    <div class="flex flex-col">
                        <span class="font-medium text-green-800 dark:text-green-300">{{ selectedFile()?.name }}</span>
                        <span class="text-xs text-green-600 dark:text-green-400">
                            {{ (selectedFile()?.size || 0) / 1024 | number:'1.2-2' }} KB
                        </span>
                    </div>
                </div>
                <button mat-icon-button (click)="removeFile()" [disabled]="isUploading()">
                    <mat-icon svgIcon="heroicons_outline:x-circle"></mat-icon>
                </button>
            </div>
        </div>
        }

        <!-- Hidden File Input -->
        <input
            #fileInput
            type="file"
            accept=".csv"
            (change)="onFileInputChange($event)"
            style="display: none;">

        <!-- Progress Bar -->
        @if (isUploading()) {
        <div class="flex flex-col space-y-2">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            <span class="text-sm text-center text-gray-600 dark:text-gray-400">
                Importando usuários...
            </span>
        </div>
        }

        <!-- Action Buttons -->
        <div class="flex flex-row justify-end space-x-3 pt-4">
            <button mat-stroked-button (click)="onCancelClick()" [disabled]="isUploading()">
                Cancelar
            </button>
            <button 
                mat-flat-button 
                color="primary" 
                (click)="onImportClick()" 
                [disabled]="!selectedFile() || isUploading()">
                <mat-icon svgIcon="heroicons_outline:arrow-up-tray"></mat-icon>
                <span class="ml-2">Importar</span>
            </button>
        </div>
    </div>
</div>
